export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-navy-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-display font-bold mb-4">
              Iron Asset Management LLC
            </h3>
            <p className="text-grey-300 mb-4 leading-relaxed">
              Multi-service solutions for businesses, properties, vehicles, and operational assets.
            </p>
            <div className="space-y-2">
              <a 
                href="tel:+13313213509" 
                className="flex items-center gap-2 text-grey-300 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                <span>(331) 321-3509</span>
              </a>
              <a 
                href="mailto:info@ironassetmanagement.com" 
                className="flex items-center gap-2 text-grey-300 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                <span>info@ironassetmanagement.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-grey-200">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-grey-300 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-grey-300 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-grey-300 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-grey-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-grey-200">Our Services</h4>
            <ul className="space-y-2 text-grey-300">
              <li>General Business Services</li>
              <li>Property Support Services</li>
              <li>Automotive Services</li>
              <li>Asset Management</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-grey-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-grey-400 text-sm">
              © {new Date().getFullYear()} Iron Asset Management LLC. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-grey-400 hover:text-white transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
